import api from '@/services/api/api'
import TokenService from '@/services/auth/TokenService'
import router from '@/router'

let refreshTokenPromise = null

const jwtInterceptor = (store) => {
  api.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken()

      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  api.interceptors.response.use(
    (res) => {
      return res
    },
    async (err) => {
      const originalConfig = err.config

      console.log(err)

      if (originalConfig.url === '/auth/authenticate' || originalConfig.url === '/auth/authenticate-link') {
        return Promise.reject(err)
      }

      if (originalConfig.url === '/auth/refresh-token' || originalConfig.url === '/auth/authenticate-re-link') {
        TokenService.removeLogin()
        store.commit('authentication/LOGOUT')

        console.log(originalConfig.url)
        if (router.currentRoute.path !== '/Login') {
          router.push('/Login')
        }
        return Promise.reject(err)
      }

      if (err.response) {
        if (err.response.status === 401 && !originalConfig.retry) {
          originalConfig.retry = true

          // is link login
          if (store.getters['authentication/accessType'] === 1) {
            try {
              if (refreshTokenPromise) {
                await refreshTokenPromise
              } else {
                refreshTokenPromise = store.dispatch('authentication/loginReLink')
                await refreshTokenPromise
                refreshTokenPromise = null
              }
              originalConfig.headers['Authorization'] = 'Bearer ' + TokenService.getLocalAccessToken()
              return api.request(originalConfig)
            } catch (error) {
              return Promise.reject(error)
            }
          }

          // is normal login
          if (store.getters['authentication/accessType'] === 2) {
            try {
              let rs
              if (refreshTokenPromise) {
                rs = await refreshTokenPromise
              } else {
                refreshTokenPromise = api.post('/auth/refresh-token', {
                  accessToken: TokenService.getLocalAccessToken(),
                  refreshToken: TokenService.getLocalRefreshToken()
                })
                rs = await refreshTokenPromise
                refreshTokenPromise = null
              }

              const accessToken = rs.data.accessToken
              const refreshToken = rs.data.refreshToken

              store.dispatch('authentication/refreshToken', { accessToken, refreshToken })

              const accessData = { accessToken: accessToken, refreshToken: refreshToken }

              TokenService.updateLocalAccessData(accessData)

              originalConfig.headers['Authorization'] = 'Bearer ' + TokenService.getLocalAccessToken()

              return api.request(originalConfig)
            } catch (error) {
              return Promise.reject(error)
            }
          }
        }
      }

      return Promise.reject(err)
    }
  )
}

export default jwtInterceptor



// WEBPACK FOOTER //
// ./src/services/api/jwtInterceptor.js